export default __webpack_public_path__ + "a6ebfdef0d3447246fdff6da8b85a01d.png";